// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2131":"5d91429a","2729":"efe88785","5509":"6b2d44fa","9667":"c11c8404"}[chunkId] + ".chunk.css";
};